import { get, post } from './axios'

export default {
  // 查询 CA 认证状态 + 意愿类型
  // 返回 data: {
  //   caStatus: 个人CA状态 0=未认证, 非0=已认证
  //   intendType: 个人意愿类型 1=意愿短信签, 其他=普通方式
  //   newCa: 是否是新规个人CA 1=是 0=否
  //   comCaStatus: 企业CA状态 0=未认证, 非0=已认证
  //   comIntendType: 企业意愿类型 1=意愿短信签, 其他=普通方式
  //   comNewCa: 是否是新规企业CA 1=是 0=否
  // }
  getCaStatus() {
    return get('/user/ca/getCaStatus')
  },
  // 发送意愿认证短信
  // 返回 data: { orderNo }
  getSignMsg() {
    return get('/user/ca/getSignMsg')
  },
  // 校验意愿认证验证码
  // 入参 { code, orderNo };返回 data: { status, msg },status:1=成功
  verifySignMsg(param) {
    return post('/user/ca/verifySignMsg', param)
  },
  // 企业申请CA认证（法人在线认证）
  // 入参 CorpCaVo；返回 { orderNo, url }
  applyCorpCaVerify(param) {
    return post('/user/ca/updateApplyCorpCaVerify', param)
  },
  // 查询企业CA认证状态
  // 入参 { id }；返回 { status, msg, ... }
  queryCorpCaVerify(param) {
    return get('/user/ca/updateQueryCorpCaVerify', param)
  },
  // 获取企业CA经办人信息
  // 返回 { userId, ... }，用于校验当前账号是否为企业 CA 经办人
  getCorpCaOperatorInfo() {
    return get('/user/ca/getCorpCaOperatorInfo')
  },
}
